<template>
    <div>
        <div class="row">
            <div class="small-12 medium-12 columns lp end">
                <div :class="{'error': errors.has('Frame Choice') }">

                    <label for="labSupplyFrame">Frame: *</label>
                    <div class="row">
                        <div class="columns medium-8">
                            <select id='labSupplyFrame' v-validate data-vv-rules="required" class="orderinput-select" name="Frame Choice" v-model="sampleobject.labSuppliedFrame">
                                <option selected value> </option>
                                <!--<option v-for="f in program.frameChoices" :value="f" :key="f.upc">{{f.manufacturer | upperCase}} {{f.upc | subStr}}</option>-->
				<option v-for="f in program.frameChoices" :value="f" :key="f.upc">{{f.manufacturer | upperCase}} {{f.model}} {{f.color}}</option>
                            </select>
                        </div>
                        <div class="columns medium-4">
                            <b v-if="!isConcentrixSampleProgram"><a :href="framePdf" target="_blank">Download the Frames PDF</a></b>
                            <div v-if="isConcentrixSampleProgram">
                              <p>
                                <b><a :href="emperioArmaniPdf" target="_blank">Download the frames PDF (Emporio Armani)</a></b>
                              </p>
                              <p>
                                <b><a :href="coachPdf" target="_blank">Download the frames PDF (Coach)</a></b>
                              </p>
                              <p>
                                <b><a :href="raybanPdf" target="_blank">Download the frames PDF (Rayban)</a></b>
                              </p>
                            </div>
                        </div>
                    </div>

                    <p class="error" v-if="errors.has('Frame Choice')">{{ errors.first('Frame Choice') }}</p>
                </div>
            </div>

        </div>
        <div class="row">

        </div>
    </div>
</template>
<script>
import Vue from "vue";

export default {
  props: ["sampleobject", "program"],
  inject: ["$validator"],
  created() {},
  computed: {
    framePdf() {
      if (
        this.sampleobject.programId == "LUXUS" ||
        this.sampleobject.programId == "LUXUP"
      ) {
        return Vue.config.HOST_URL + "FreeFitFrameSelection.pdf";
      } else if (
        this.sampleobject.programId == "RBAS1" ||
        this.sampleobject.programId == "RBAP1"
      ) {
        return Vue.config.HOST_URL + "RB- AE Samples Assortment.pdf";
      } else if (
        this.sampleobject.programId == "RBAS2" ||
        this.sampleobject.programId == "RBAP2"
      ) {
        return Vue.config.HOST_URL + "RB_Sample_Product_Catalog051121.pdf";
      } else
        return Vue.config.HOST_URL + "22667_PRO_TRN Evaluation Unit Program Frames.pdf";
    },
    emperioArmaniPdf() {
      return Vue.config.HOST_URL + "FrameDream_Collection_EmporioArmani.pdf";
    },
    coachPdf() {
      return Vue.config.HOST_URL + "FrameDream_Collection_Coach.pdf";
    },
    raybanPdf() {
      return Vue.config.HOST_URL + "FrameDream_Collection_Rayban.pdf";
    },
    isConcentrixSampleProgram() {
      return (this.sampleobject.programId == 'TRCPP' || this.sampleobject.programId == 'TRCPS');
    }
  },
  filters: {
    subStr: (str) => {
      return str.substring(str.length - 4, str.length);
    },
    upperCase: (str) => {
      if(str)
        return str.toUpperCase();
      else 
        return '';
    }
  }
};
</script>